import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TApiPaginatedResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAccrualBalancesRequestSchema,
  TGetAccrualBalancesResponseSchema,
} from "./getAccrualBalances.schema";

export const getAccrualBalances = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    limit,
    start_at,
    q,
    policy_type,
    sort_direction,
    sort_by,
  }: TGetAccrualBalancesRequestSchema) => {
    const { data } = await axios.noRetry.get<
      TApiPaginatedResponse<TGetAccrualBalancesResponseSchema>
    >(`/accrual-policies/balances`, {
      params: {
        companyID,
        limit,
        start_at,
        q,
        policy_type,
        sort_direction,
        sort_by,
      },
    });

    if (data.success) {
      return data;
    }

    throw new Error("Something went wrong");
  };
};
